import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {NavService} from './nav-service';
import {EparcoursPath} from '../../constantes/menu/menu-items/eparcours-path';
import {PARAM_TOKEN} from './navigators/navigators';

@Injectable({
  providedIn: 'root',
})
export class ArticlesNavService extends NavService {
  constructor(router: Router) {
    super(router);
  }

  edition = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.ARTICLES,
    EparcoursPath.articles.EDITION,
    PARAM_TOKEN,
    EparcoursPath.articles.EDITION_GENERAL,
  );

  creation = this.makeNavigator(EparcoursPath.root.ARTICLES, EparcoursPath.articles.CREATION);

  liste = this.makeNavigator(EparcoursPath.root.ARTICLES);
}
